<template>
  <div class="content">
    <router-view/>
  </div>
</template>